import axios from 'axios'
import { showFancyToast, showLoadingToast, closeToast } from '@/utils/toast'
import successIcon from '@/assets/images/store/1.webp'
import errorIcon from '@/assets/images/store/2.webp'
import { showErrorToast } from '@/utils/toast'
import { appStorage } from '@/utils/storage'
import { logEventSafe } from '@/plugins/firebase'
import { useUserStore } from '@/stores/user'

// 导入图片资源
import rechargeImg from '@/assets/images/store/recharge.webp'
import checkinImg from '@/assets/images/store/check.webp'

import photoImg from '@/assets/images/store/photo.webp'
import otherImg from '@/assets/images/message/other.svg'
import messageImg from '@/assets/images/store/message.webp'
import rawImage from '@/assets/images/store/rawImage.svg'
import tiliImg from '@/assets/images/store/tili.svg'


/**
 * 检查订单支付状态
 * 场景：当用户支付完成后从支付页跳回到 H5 页面，
 *       根据 URL 中的 orderNo 查询该订单是否支付成功。
 */
export const getCheckOrderStatus = async () => {
  const orderNoCheck = localStorage.getItem('orderNoCheck')
  const params = new URLSearchParams(window.location.search)
  const orderNo = params.get('orderNo')
  if (!orderNo) {
    return
  }
  if (!orderNoCheck) return

  showLoadingToast('Processing...')

  const response = await axios({
    method: 'post',
    url: orderNoCheck,
    data: {
      orderNo: orderNo
    }
  })

  if (response.data.code === '200') {
    showFancyToast('Thank you for your purchase', {
      subtitle: "Automatically Close in 5''",
      icon: successIcon,
      duration: 1000
    })
    // logEventSafe('pay_success');
    // localStorage.setItem('first_pay_success_to_tabstore', '1')
    const userStore = useUserStore()
    await userStore.getUserInfo()

    // if(localStorage.getItem('is_store_popup') === '1') {
    //   logEventSafe('storepopup_pay_success');
    // }
  } else {
    showFancyToast('Payment failed. Please try again', {
      subtitle: "Automatically Close in 5''",
      icon: errorIcon,
      duration: 1000
    })
  }
  localStorage.removeItem('orderNoCheck')
}

export const getH5Payment = async (
  item: any,
  index: number = 0,
  userInfo: any,
  deviceStorage: any
) => {
  showLoadingToast('Processing...')
  try {
    const paymentData = {
      productId: item.list[index].productId,
      userId: userInfo?.userId,
      appId: appStorage.getAppId(),
      redirectUrl: window.location.origin + '/store',
      udid: deviceStorage.getUdid()
    }

    const url = item.apiUrl

    const response = await axios({
      method: 'post', // 或者 'get'，看接口文档
      url: url,
      data: paymentData, // POST 请求体参数
      // params: payParams,         // 如果是 GET 请求则使用 params
      headers: {
        'Content-Type': 'application/json' // 根据接口期望设置
        // 如需签名、token，可在此加上 headers
      },
      timeout: 15000 // 超时时间，可按需调整
    })

    showErrorToast(response.data.message)

    if (!window._isNavigating) {
      window._isNavigating = true
      window.location.href = response.data.data.checkoutUrl // 例如这个链接
      setTimeout(() => {
        window._isNavigating = false
      }, 3000)
    }
    // if()
    localStorage.setItem('orderNoCheck', response.data.data.orderNoCheck)
  } catch (error: any) {
    showErrorToast('Payment failed, please try again')
  } finally {
    closeToast()
  }
}

/**
 * 类型type
 */

export const TypeMap: Record<number, string> = {
  1: 'Sign-up Bonus',
  2: 'Welcome Back Gift',
  5: 'Free Claim',
  6: 'Complete Profile Reward',
  7: 'Watch Ad Reward',
  8: 'Check-in',
  10: 'Purchase',
  15: 'Admin Grant',
  20: 'Message Cost',
  21: 'Unlock Scenario',
  22: 'Unlock Images',
  24: 'Buy stamina',
  23: 'Image Generation',
  30: 'Failed Task Refund'
}

export const TypeMapImg: Record<number, string> = {
  1: otherImg,
  2: otherImg,
  5: otherImg,
  6: otherImg,
  7: otherImg,
  8: checkinImg,
  10: messageImg,
  15: otherImg,
  20: rechargeImg,
  21: otherImg,
  22: photoImg,
  23: rawImage,
  24: tiliImg,
  30: otherImg
}

export const TypeMapColor: Record<number, string> = {
  1: '#7284F7',
  5: '#7284F7',
  6: '#7284F7',
  7: '#FFFF',
  8: '#7284F7',
  15: '#FFFF',
  10: '#7284F7',
  20: '#FFFF',
  22: '#FFFF'
}
